<template>
  <div class="logo-container">
    <router-link :to="$i18nRoute({ name: 'home' })">
      <div class="logo">
        <img id="logo-vexpo" src="@/assets/header/logo.svg" alt="Logo">
      </div>
    </router-link>
  </div>
</template>

<script>

export default {
  name: 'Menu',
  components: {},
  data() {
    return {
      publicPath: process.env.BASE_URL
    }

  },

}

</script>

<style lang="scss">

.logo {
  position: relative;
  display: inline-block;
  margin-right: 60px;

  &::after {
    position: absolute;
    content: 'beta';
    color: rgba(114, 114, 114, 1);
    text-transform: uppercase;
    right: -44px;
    font-weight: bold;
  }
}
</style>
